import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async connect() {
    const { highlightAllIn } = await import("../shared/shiki_highlight")
    await highlightAllIn(this.element)
  }
}
